var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2319_3150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66876C11.6482 1.66876 13.2593 2.1575 14.6298 3.07318C16.0002 3.98886 17.0683 5.29035 17.699 6.81306C18.3297 8.33578 18.4948 10.0113 18.1732 11.6278C17.8517 13.2444 17.058 14.7292 15.8926 15.8947C14.7271 17.0601 13.2423 17.8538 11.6258 18.1753C10.0092 18.4968 8.33369 18.3318 6.81098 17.7011C5.28826 17.0704 3.98677 16.0023 3.07109 14.6318C2.15541 13.2614 1.66667 11.6503 1.66667 10.0021C1.66667 7.79195 2.54464 5.67234 4.10745 4.10953C5.67025 2.54673 7.78987 1.66876 10 1.66876ZM10 0.00209045C8.02219 0.00209045 6.08879 0.58858 4.4443 1.68739C2.79981 2.78621 1.51809 4.348 0.761209 6.17526C0.00433286 8.00252 -0.193701 10.0132 0.192152 11.953C0.578004 13.8928 1.53041 15.6746 2.92894 17.0732C4.32746 18.4717 6.10929 19.4241 8.0491 19.8099C9.98891 20.1958 11.9996 19.9978 13.8268 19.2409C15.6541 18.484 17.2159 17.2023 18.3147 15.5578C19.4135 13.9133 20 11.9799 20 10.0021C20 7.34993 18.9464 4.80639 17.0711 2.93102C15.1957 1.05566 12.6522 0.00209045 10 0.00209045V0.00209045Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7104 8.92709C14.9666 8.63126 14.7791 8.13542 14.4104 8.13542H10.7999C10.7873 8.13597 10.7747 8.13348 10.7632 8.12816C10.7518 8.12284 10.7417 8.11484 10.734 8.10485C10.7262 8.09485 10.721 8.08314 10.7187 8.0707C10.7164 8.05826 10.7171 8.04545 10.7208 8.03334L11.8749 4.82917C12.0437 4.35626 11.5083 3.96459 11.1895 4.32917L5.2916 11.0729C5.03327 11.3667 5.21869 11.8625 5.58744 11.8646L9.32077 11.8771L8.14785 15.1771C7.9791 15.6521 8.5166 16.0396 8.83327 15.675L14.7104 8.92709Z",
    fill: "#84B0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2319_3150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.dbd98ba774c68d1032b208b3d99c628a.svg";
export { ForwardRef as ReactComponent };